var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105.058,
    height: 96.303,
    viewBox: "0 0 105.058 96.303",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#14ffa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15e584"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_299060_folder_icon",
    "data-name": "299060_folder_icon",
    transform: "translate(0 -1029.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M8.755,1033.4A8.768,8.768,0,0,0,0,1042.155v61.284a8.768,8.768,0,0,0,8.755,8.755H96.3a8.766,8.766,0,0,0,8.755-8.755v-61.284A8.767,8.767,0,0,0,96.3,1033.4Z",
    transform: "translate(0 13.51)",
    fill: "#2c9263"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M9.755,1029.4A8.768,8.768,0,0,0,1,1038.155v61.283a8.768,8.768,0,0,0,8.755,8.755H88.548a8.766,8.766,0,0,0,8.755-8.755v-52.529a8.766,8.766,0,0,0-8.755-8.755H53.529L40.4,1029.4Z",
    transform: "translate(3.377 0)",
    fill: "#2c9263"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M97.3,1076.174v-35.019a8.766,8.766,0,0,0-8.755-8.755H9.755A8.768,8.768,0,0,0,1,1041.155v35.019Z",
    transform: "translate(3.377 10.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M8.755,1033.4A8.768,8.768,0,0,0,0,1042.155v56.906a8.768,8.768,0,0,0,8.755,8.755H96.3a8.766,8.766,0,0,0,8.755-8.755v-56.906A8.767,8.767,0,0,0,96.3,1033.4Z",
    transform: "translate(0 13.51)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEFolder);
export default __webpack_public_path__ + "static/media/eFolder.62c65b58984b611845a6d420e929eb3c.svg";
export { ForwardRef as ReactComponent };